"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _Feature = _interopRequireDefault(require("../utils/features/Feature"));

var _FeatureManager = _interopRequireDefault(require("../utils/features/FeatureManager"));

var _UserManagementService = _interopRequireDefault(require("../common/components/Equizzer/services/UserManagementService"));

var _ActivationCodeHelperStrings = require("./ActivationCodeHelperStrings");

var _StringHelper = _interopRequireDefault(require("./StringHelper"));

var _AlertHelper = require("./AlertHelper");

// import { checkActivationCode, isActivated } from './CordovaHelper'
// import DataStoreActions from '../KESI2/Stores/DataStoreActions'
// import EquizzerActions from '../common/components/Equizzer/actions/EquizzerActions'
// import { USER_AUTH_PATH } from '../common/constants/Constants'
var ActivationCodeHelper = /*#__PURE__*/function () {
  (0, _createClass2["default"])(ActivationCodeHelper, null, [{
    key: "activateForFeature",
    value: function activateForFeature(label, title, expectedFeature, checkWithAuthServer) {
      var activationCodeHelper = new ActivationCodeHelper(label, title, expectedFeature);
      activationCodeHelper.showDialog(checkWithAuthServer);
    }
  }, {
    key: "activate",
    value: function activate(label, title, checkWithAuthServer) {
      var activationCodeHelper = new ActivationCodeHelper(label, title, null);
      activationCodeHelper.showDialog(checkWithAuthServer);
    }
  }]);

  function ActivationCodeHelper(label, title) {
    var expectedFeature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    (0, _classCallCheck2["default"])(this, ActivationCodeHelper);
    this.expectedFeature = expectedFeature;
    this.label = label;
    this.title = title;
    this.error = null;
    this.id = _StringHelper["default"].createShortId();
    this.activationCodeToCheck = '';
  }

  (0, _createClass2["default"])(ActivationCodeHelper, [{
    key: "onActivationCodeChange",
    value: function onActivationCodeChange(evt) {
      this.activationCodeToCheck = evt.target.value;
    }
  }, {
    key: "onActivationCodeEntered",
    value: function () {
      var _onActivationCodeEntered = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(checkWithAuthServer) {
        var _this = this;

        var registerSilent,
            returnValue,
            existingFeatures,
            anyFeatureUpdated,
            okButton,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                registerSilent = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                this.error = null;
                _context.prev = 2;
                _context.next = 5;
                return _UserManagementService["default"].checkActivationCode(this.activationCodeToCheck, null, checkWithAuthServer);

              case 5:
                returnValue = _context.sent;

                if (!returnValue.success) {
                  _context.next = 31;
                  break;
                }

                if (!(!this.expectedFeature || returnValue.features.indexOf(this.expectedFeature) >= 0)) {
                  _context.next = 26;
                  break;
                }

                existingFeatures = returnValue.features.map(function (featureName) {
                  return _FeatureManager["default"].getFeature(featureName);
                }); // update user values for each existing feature

                anyFeatureUpdated = false;
                existingFeatures.forEach(function (feature) {
                  if (!feature) {
                    return;
                  }

                  feature.activationCode = _this.activationCodeToCheck;
                  anyFeatureUpdated = true;
                });

                if (!anyFeatureUpdated) {
                  returnValue.features.forEach(function (featureName) {
                    _FeatureManager["default"].saveFeature(new _Feature["default"](featureName, _this.activationCodeToCheck));
                  });
                }

                okButton = {
                  label: (0, _ActivationCodeHelperStrings.getString)('OK'),
                  callback: function callback() {}
                };

                if (!(returnValue.features.indexOf(_config["default"].kesiAuthorFeatureName) !== -1)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 16;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT, true);

              case 16:
                if (registerSilent) {
                  window.location.reload();
                } else {
                  okButton = {
                    label: (0, _ActivationCodeHelperStrings.getString)('OK'),
                    callback: function callback() {
                      window.location.reload();
                    }
                  };
                }

              case 17:
                if (!(returnValue.features.indexOf(_config["default"].kesiMasterFeatureName) !== -1)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 20;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.IS_KESI_MASTER, true);

              case 20:
                if (!(returnValue.features.indexOf(_config["default"].kesiExpertFeatureName) !== -1)) {
                  _context.next = 23;
                  break;
                }

                _context.next = 23;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.IS_KESI_EXPERT, true);

              case 23:
                if (!registerSilent) {
                  (0, _AlertHelper.showAlertWithOptions)({
                    message: (0, _ActivationCodeHelperStrings.getString)('SUCCESSFULLY_ACTIVATED_MESSAGE'),
                    title: (0, _ActivationCodeHelperStrings.getString)('SUCCESSFULLY_ACTIVATED_TITLE'),
                    size: 'large',
                    buttons: [okButton]
                  });
                } // showWideAlert(getString('SUCCESSFULLY_ACTIVATED_MESSAGE'), getString('SUCCESSFULLY_ACTIVATED_TITLE'))


                _context.next = 29;
                break;

              case 26:
                console.error((0, _ActivationCodeHelperStrings.getString)('ERROR_ACTIVATION_WRONG_FEATURE')); // TODO: deactivate feature via FeaturePlugin

                this.error = (0, _ActivationCodeHelperStrings.getString)('ERROR_ACTIVATION_WRONG_FEATURE');
                this.showDialog(checkWithAuthServer);

              case 29:
                _context.next = 34;
                break;

              case 31:
                console.log((0, _ActivationCodeHelperStrings.getString)('ERROR_ACTIVATION_WRONG_FEATURE'));
                this.error = (0, _ActivationCodeHelperStrings.getString)('ERROR_ACTIVATION_WRONG_FEATURE');
                this.showDialog(checkWithAuthServer);

              case 34:
                _context.next = 41;
                break;

              case 36:
                _context.prev = 36;
                _context.t0 = _context["catch"](2);
                console.error({
                  error: _context.t0
                });
                this.error = (0, _ActivationCodeHelperStrings.getString)('ERROR_ACTIVATION_WRONG_FEATURE');
                this.showDialog(checkWithAuthServer);

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 36]]);
      }));

      function onActivationCodeEntered(_x) {
        return _onActivationCodeEntered.apply(this, arguments);
      }

      return onActivationCodeEntered;
    }()
  }, {
    key: "showDialog",
    value: function () {
      var _showDialog = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(checkWithAuthServer) {
        var _this2 = this;

        var resetTrainerCode, trainerCode, isAlreadyActivated, textfields, cancelButton, okButton;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                resetTrainerCode = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TRAINER_CODE_ON_RESET);
                trainerCode = resetTrainerCode || _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TRAINER_CODE_ON_REGISTRATION);

                if (!(trainerCode && this.error === null)) {
                  _context2.next = 7;
                  break;
                }

                this.activationCodeToCheck = trainerCode;
                this.onActivationCodeEntered(checkWithAuthServer, true);
                _context2.next = 18;
                break;

              case 7:
                if (!this.expectedFeature) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 10;
                return _UserManagementService["default"].isActivated(this.expectedFeature);

              case 10:
                isAlreadyActivated = _context2.sent;

                if (!isAlreadyActivated) {
                  _context2.next = 14;
                  break;
                }

                (0, _AlertHelper.showAlertWithOptions)({
                  message: (0, _ActivationCodeHelperStrings.getString)('FEATURE_ALREADY_ACTIVATED_MESSAGE'),
                  size: 'large'
                }); // showWideAlert(getString('FEATURE_ALREADY_ACTIVATED_MESSAGE'), null)

                return _context2.abrupt("return");

              case 14:
                textfields = [{
                  label: '',
                  type: 'text',
                  onChange: function onChange(evt) {
                    return _this2.onActivationCodeChange(evt);
                  },
                  ref: this.id,
                  className: ''
                }];
                cancelButton = {
                  label: (0, _ActivationCodeHelperStrings.getString)('CANCEL'),
                  callback: function callback() {}
                };
                okButton = {
                  label: (0, _ActivationCodeHelperStrings.getString)('OK'),
                  callback: function callback() {
                    return _this2.onActivationCodeEntered(checkWithAuthServer);
                  }
                };
                (0, _AlertHelper.showWideAlertHtmlWithTextfields)(this.label, this.title, this.error, textfields, true, null, [okButton, cancelButton]);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function showDialog(_x2) {
        return _showDialog.apply(this, arguments);
      }

      return showDialog;
    }()
  }]);
  return ActivationCodeHelper;
}();

var _default = ActivationCodeHelper;
exports["default"] = _default;